import * as React from 'react';
/**
 *
 * Original name: Patreon
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22641%3A2828
 *
 */
export const PatreonExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.696 5a5.455 5.455 0 0 0-5.446 5.451c0 2.997 2.443 5.435 5.446 5.435a5.438 5.438 0 0 0 5.429-5.435c0-3.006-2.435-5.45-5.429-5.45ZM5 19.52h2.659V5H5v14.52Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
